import { render, staticRenderFns } from "./alertaAbasIncompletasFechavel.vue?vue&type=template&id=223f7f76&"
import script from "./alertaAbasIncompletasFechavel.vue?vue&type=script&lang=js&"
export * from "./alertaAbasIncompletasFechavel.vue?vue&type=script&lang=js&"
import style0 from "./alertaAbasIncompletasFechavel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports